import { Component, Input, OnInit, effect, inject } from '@angular/core';
import { SharedSignalsService } from '../../services/shared-signals.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'taly-shop-card',
    templateUrl: './shop-card.component.html',
    styleUrls: ['./shop-card.component.scss'],
    standalone: false
})
export class ShopCardComponent implements OnInit {


  @Input() shop: any;

  transferSignal = inject(SharedSignalsService);
  textDirection: any;

  constructor(private router: Router) {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    })
  }

  ngOnInit(): void {

  }

  handleImageError(event: any) {
    event.target.src = 'assets/images/merchant-store.svg';
  }

  getMerchantFeaturedUrl(url) {
    if (url) {
      return url;
    } else {
      //return 'assets/images/Merchants.png'
    }
  }


  redirectToMerchantSite(url: string) {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    const urlWithoutProtocol = url.replace(/^https?:\/\//, '');
    if (!urlWithoutProtocol.startsWith('www.')) {
      url = url.replace(/^https?:\/\//, 'https://www.');
    }
    window.open(url, '_blank');
  }



}
